import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';
import type { PendingPickup } from '../types/pickup.types';

interface ApiData<T> {
  data: T;
}

export function usePendingPickups() {
  return useQuery({
    queryKey: ['pending-pickups'],
    queryFn: async () => {
      const response = await apiClient.get<ApiData<PendingPickup[]>>('/order/pickups/pending');
      return response.data?.data ?? [];
    },
  });
}
